<div class="appr-page">
  <div class="appr-card">
    <div class="appr-hero">
      <img src="assets/img/mailing/mockups.png" class="appr-device" alt="Cardata Mobil">
    </div>

    <div class="appr-body">
      <img src="assets/img/mailing/cardata-logo-square.png" class="appr-logo" alt="Cardata">
      <h1 class="appr-title">Cardata Mobil Uygulaması</h1>
      <p class="appr-desc">
        Araç değerleme cebinizde. Uygulamayı açın ya da indirerek dilediğiniz an,
        dilediğiniz yerden fiyat sorgulayın.
      </p>

      <!-- Mobile: primary "open in app" action -->
      <button *ngIf="deviceType !== 'desktop'" class="appr-cta" (click)="openApp()">
        Uygulamada Aç
      </button>

      <div class="appr-stores">
        <a [href]="playStoreUrl" target="_blank" rel="noopener">
          <img src="assets/img/mailing/btn-playstore.png" alt="Google Play'den İndir" class="appr-store-img">
        </a>
        <a [href]="appStoreUrl" target="_blank" rel="noopener">
          <img src="assets/img/mailing/btn-appstore.png" alt="App Store'dan İndir" class="appr-store-img">
        </a>
      </div>

      <a routerLink="/" class="appr-home">Web sitesine git</a>
    </div>
  </div>
</div>
